export default __webpack_public_path__ + "static/media/swap.c6754141.svg";